import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Configuracion Parking',
            tblTitle: 'Lista de Atributos',
            tblbutton: 'Nuevo Atributo',
            mdlSave: 'Guardar',
            mdlCancel: 'Cancelar',
            mdltext1: 'Atributo',
            mdltext2: 'Descripción',
        },
        en: {
            moduleTitle: 'Attributes',
            tblTitle: 'Attributes List',
            tblbutton: 'New Attributes',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',
            mdltext1: 'Attributes',
            mdltext2: 'Description',
        }
    }
}

export default _.merge(messages, defaultMessages)